import type { Country } from '../data/countries'

const stripPhone = (value: string) => value.trim().replace(/[\s.()-]/g, '')

export function normalizePhone(country: Country, localPhone: string) {
  const raw = stripPhone(localPhone)
  if (!raw) return ''
  const digits = raw.replace(/\D/g, '')
  const dialDigits = country.dialCode.replace(/\D/g, '')
  if (raw.startsWith('+')) return `+${digits}`
  if (digits.startsWith(dialDigits)) return `+${digits}`
  return `${country.dialCode}${digits}`
}

export function isValidPhone(country: Country, value: string) {
  const normalized = normalizePhone(country, value)
  return /^\+[1-9]\d{6,14}$/.test(normalized)
}
